import { AxiosResponse } from 'axios';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleSuccess = (res: AxiosResponse) => {
  const { method } = res.config;
  const checkUrl = (url: string) => {
    let isShowNotification = false;
    const urls = ['users', 'user/', 'asset-manager', 'facility-manager', 'user-manager/crud/apikey', '/report-server'];
    urls.forEach((el) => {
      if (url.indexOf(el) !== -1) {
        isShowNotification = true;
      }
    });
    return isShowNotification;
  };

  if (method !== 'get' && checkUrl(res.config.url as string)) {
    // eslint-disable-next-line no-nested-ternary
    // const description = `${method === 'post' ? 'Adding' : method ===
    // 'put' ? 'Updating' : 'Deleting'} was successful!`;
    // notification.success({
    //   placement: 'topRight',
    //   bottom: 50,
    //   duration: 3,
    //   message: 'Success',
    //   description,
    //   className: 'notification-type-info',
    // });
  }
};

export default handleSuccess;
